import React from "react"

import styles from "./pricing.module.scss"
import MembershipCard from "./MembershipCard"

const Membership = () => {


  return (
    <div className={styles.membership}>
      {/* <h3 className={styles.membershipText}>Select your membership</h3> */}
      <div className={styles.membershipCards}>
        <MembershipCard />
        {/* <MembershipCard full /> */}
      </div>
    </div>
  )
}

export default Membership
